module.exports = window.location.pathname.split('/')[2]